export default "__VITE_ASSET__CguFjDrf__"